import React, { useState } from 'react';
import DownloadApp from '../components/DownloadApp';
import { Link } from 'react-router-dom';
import { useUserProfileContext } from '../components/ProtectedRoute';
import { AUTH_COMPLETE_ACCOUNT, HOME } from '../routes/paths';
import './Profile.css';

function Profile() {
  const [failedPhoto, setFailedPhoto] = useState(null);
  const { profile, loading, error, refetchProfile } = useUserProfileContext();
  const user = profile?.data?.user || profile?.data || profile?.user || profile;
  const complete = user?.is_complete_account ?? (localStorage.getItem('isCompleteAccount') === 'true');
  const displayValue = (value) => typeof value === 'string' || typeof value === 'number' ? value : 'Not provided';
  const mobile = user?.mobile_number
    ? [user.country_code, user.mobile_number].filter(Boolean).join(' ')
    : 'Not provided';
  const stats = [
    ['Events hosted', user?.total_events_hosted],
    ['Events attended', user?.events_attended_count],
    ['Guests invited', user?.total_guests_invited],
    ['Photos uploaded', user?.total_images_uploaded],
    ['RSVPs approved', user?.rsvp_approved_count],
  ];

  return (
    <div className="profile-page">

      <main className="profile-main">
        <section className="profile-card" aria-labelledby="profile-title">
          <p className="profile-eyebrow">YOUR CLICK AI ACCOUNT</p>
          <h1 id="profile-title">My profile</h1>
          {loading || (!profile && !error) ? <p role="status">Loading your profile…</p> : error ? (
            <div role="alert">
              <p>{error}</p>
              <button onClick={refetchProfile} type="button">Try again</button>
            </div>
          ) : (
            <>
              <div className="profile-identity">
                {user?.profile_pic && failedPhoto !== user.profile_pic ? (
                  <img className="profile-avatar" src={user.profile_pic} alt="Profile" width="80" height="80"
                    onError={() => setFailedPhoto(user.profile_pic)} />
                ) : <span className="profile-avatar profile-avatar-fallback" aria-hidden="true">{user?.full_name?.trim()?.charAt(0) || '?'}</span>}
                <div><h2>{displayValue(user?.full_name)}</h2><p>{user?.username ? `@${user.username}` : 'Your account'}</p></div>
              </div>
              <dl className="profile-details">
                <div><dt>Mobile number</dt><dd>{mobile}{user?.mobile_number && <span className="profile-verification" data-verified={Boolean(user.is_mobile_verified)}>{user.is_mobile_verified ? 'Verified' : 'Not verified'}</span>}</dd></div>
                <div><dt>Email</dt><dd>{displayValue(user?.email)}{user?.email && <span className="profile-verification" data-verified={Boolean(user.is_email_verified)}>{user.is_email_verified ? 'Verified' : 'Not verified'}</span>}</dd></div>
                <div><dt>Account status</dt><dd>{complete ? 'Complete' : 'Setup required'}</dd></div>
              </dl>
              {!complete && <Link className="profile-action" to={AUTH_COMPLETE_ACCOUNT}>Complete your account</Link>}
              <section className="profile-section" aria-labelledby="profile-activity-title">
                <h2 id="profile-activity-title">Your activity</h2>
                <dl className="profile-stats">{stats.map(([label, value]) => (
                  <div key={label}><dt>{label}</dt><dd>{value ?? '—'}</dd></div>
                ))}</dl>
              </section>
            </>
          )}
          <Link className="profile-home" to={HOME}>Back to home</Link>
          <DownloadApp />
        </section>
      </main>
    </div>
  );
}

export default Profile;
